interface IdomainMapping {
  [key: string]: string;
}

const RAILS = 'RAILS';
const MMT = 'MMT';

const domainMapping: IdomainMapping = {
  'www.makemytrip.com': MMT,
  'rails.makemytrip.com': RAILS
}

const getHostName = (): string => {
  if (window && window.location && window.location.hostname) {
    return window.location.hostname;
  }
  return '';
}


export const getDomainFromKey = (key: string): string => Object.keys(domainMapping)
  .find(domainKey => domainMapping[domainKey] === key)
  || RAILS;

export const getKeyFromDomain = (): string => domainMapping[getHostName()];